<!-- <div *ngIf="model" class="row" id="main-container">
<div class="col-md-9">
  <table class="machine-data">
    <tbody>
      <tr>
        <td>{{ 'Machines.Common.FriendlyName' | translate }}</td>
        <td class="value">{{model.friendlyName}}</td>
      </tr>
      <tr>
        <td>S/N</td>
        <td class="value">{{model.serialNumber}}</td>
      </tr>
      <tr>
        <td>{{ 'Machines.Common.Type' | translate }}</td>
        <td class="value">{{model.machineType.name}}</td>
      </tr>
      <tr>
        <td>{{ 'Machines.Common.Place' | translate }}</td>
        <td class="value">{{model.locality}}</td>
      </tr>
      <tr>
        <td>{{ 'Machines.Common.Address' | translate }}</td>
        <td class="value">{{model.address}}</td>
      </tr>
      <tr>
        <td>{{ 'Machines.Common.City' | translate }}</td>
        <td class="value">{{model.city}}</td>
      </tr>
      <tr>
        <td>{{ 'Machines.Common.MachineGroup' | translate }}</td>
        <td class="value">{{model.machineGroup ? model.machineGroup.name : ''}}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="col-md-3 machine-img">
  <i class="i-machine"></i>
</div>
</div> -->


@if (model) {
<table class="machine-data" id="main-container">
  <tbody>
    <tr>
      <td>{{ 'Machines.Common.FriendlyName' | translate }}</td>
      <td class="value">{{model.friendlyName}}</td>
    </tr>
    <tr>
      <td>{{ 'Machines.Common.SerialNumber' | translate }}</td>
      <td class="value">{{model.serialNumber}}</td>
    </tr>
    <tr>
      <td>{{ 'Machines.Common.Type' | translate }}</td>
      <td class="value">{{model.machineType.name}}</td>
    </tr>
    <tr>
      <td>{{ 'Machines.Common.Place' | translate }}</td>
      <td class="value">{{model.locality}}</td>
    </tr>
    <tr>
      <td>{{ 'Machines.Common.Address' | translate }}</td>
      <td class="value">{{model.address}}</td>
    </tr>
    <tr>
      <td>{{ 'Machines.Common.City' | translate }}</td>
      <td class="value">{{model.city}}</td>
    </tr>
    <tr>
      <td>{{ 'Machines.Common.MachineGroup' | translate }}</td>
      <td class="value">{{model.machineGroup ? model.machineGroup.name : ''}}</td>
    </tr>
  </tbody>
</table>
}